import React from 'react'
import PropTypes from 'prop-types'
import { RadioGroup, Clipped, Text } from '@deseretbook/react-ui'

/**
 * Shipping address form field for use in the subscriptions signup.
 *
 * @returns {function} Component
 */
const ShippingAddressFormField = ({ subscriptionForm }) => (
  <RadioGroup
    name="shippingAddressId"
    aria-label="Delivery Address"
    selectedValue={+subscriptionForm.form.shippingAddressId}
    onChange={subscriptionForm.onFormChange}
    disabled={subscriptionForm.isLoading}
  >
    {subscriptionForm.addresses.map((address) => {
      const formattedAddress = [
        address.address1,
        address.address2,
        address.address3,
        address.city,
        address.state
          ? address.state.name
          : address.stateName,
        address.zipcode,
        address.country
          ? address.country.iso
          : null,
      ]
        .filter(Boolean)
        .join(', ')

      return (
        <RadioGroup.Option value={address.id} key={address.id}>
          <Clipped>
            <Text isBold hasEllipsis>
              {`${address.firstname} ${address.lastname}`}
            </Text>
            <Text hasEllipsis>{formattedAddress}</Text>
          </Clipped>
        </RadioGroup.Option>
      )
    })}
  </RadioGroup>
)

ShippingAddressFormField.propTypes = {
  subscriptionForm: PropTypes.shape({
    addresses: PropTypes.array,
    form: PropTypes.shape({}),
    onFormChange: PropTypes.func,
    isLoading: PropTypes.bool,
  }).isRequired,
}

export default ShippingAddressFormField
